import { useTranslation } from 'react-i18next';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { type FC } from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { generateFullName } from 'utils/badgeHelpers';

import s from './styles.module.scss';

import type { IActivityComments } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface ReviewedItemProps {
  comment: IActivityComments;
}

const ReviewedItem: FC<ReviewedItemProps> = ({ comment }) => {
  const { t } = useTranslation();

  return (
    <li
      data-cy="comment-reviewed"
      className={s['reviewed-item']}
      key={comment.guid}
      data-new-action={comment?.newAction}
    >
      <div className={s['reviewed-item-wrapper']}>
        <div className={s['reviewed-item-content']}>
          <div className={s['sent-check-mark']}>
            <CheckCircleOutlined />
          </div>

          <p className={s['reviewed-item-title']}>
            {t('labels.readingWasReviewed')}
          </p>
        </div>
        <p className={s['reviewed-item-signed-by']}>
          <span>{t('labels.electronicallySignedBy')}:</span>
          <span>
            {generateFullName(
              comment.createdByTitle,
              comment.createdByFirstName,
              '',
              comment.createdByLastName,
              comment.createdByProfessionType,
            )}
          </span>
          <span> • </span>
          <span className={s['reviewed-item-date']}>
            {DateFormatter({
              date: comment.createdAt,
              format: DateFormats['MM/dd/yy, hh:mm a'],
            })}
          </span>
        </p>
      </div>
    </li>
  );
};
export default ReviewedItem;
